import { PriceType, ValidationFormat } from '@wix/ambassador-forms-v4-form/types';
import { EMPTY_VALUE, FIELD_TYPES, getVatIDType } from '@wix/form-fields';
import { MultilineAddressToolkit } from '@wix/form-multiline-address';
import { isNumber, isObject, isRating, isString } from '../../services/utils';
export const normalizeValues = function (form, values, recursive, config) {
  if (recursive === void 0) {
    recursive = true;
  }
  if (!(form != null && form.fields)) {
    return {};
  }
  const normalizedValues = form.fields.reduce((result, field) => {
    var _field$view, _field$view2;
    const fieldTarget = field.target;
    if (!fieldTarget) {
      return result;
    }
    const fieldValue = values == null ? void 0 : values[fieldTarget];
    const fieldType = (_field$view = field.view) == null ? void 0 : _field$view.fieldType;
    const nestedForm = (_field$view2 = field.view) == null ? void 0 : _field$view2.form;
    if (recursive && nestedForm) {
      result[fieldTarget] = normalizeValues(nestedForm, fieldValue, false, config);
    } else {
      const normalizer = NORMALIZED_VALUE[fieldType];
      if (normalizer) {
        result[fieldTarget] = normalizer({
          field,
          fieldValue,
          config
        });
      } else {
        result[fieldTarget] = fieldValue;
      }
    }
    return result;
  }, {});
  return normalizedValues;
};
export const NORMALIZED_VALUE = {
  [FIELD_TYPES.TEXT_INPUT]: acceptStringValue,
  [FIELD_TYPES.CHECKBOX_GROUP]: removeInvalidOptions,
  [FIELD_TYPES.RADIO_GROUP]: acceptOnlyValidOptionByLabel,
  [FIELD_TYPES.DROPDOWN]: acceptOnlyValidOptionByLabel,
  [FIELD_TYPES.URL_INPUT]: acceptStringValue,
  [FIELD_TYPES.NUMBER_INPUT]: acceptNumberValue,
  [FIELD_TYPES.CHALLENGES_NUMBER]: acceptNumberValue,
  [FIELD_TYPES.CHALLENGES_SHORT_TEXT]: acceptStringValue,
  [FIELD_TYPES.CHALLENGES_LONG_TEXT]: acceptStringValue,
  [FIELD_TYPES.CHALLENGES_MULTI_CHOICE]: removeInvalidOptions,
  [FIELD_TYPES.CHALLENGES_IMAGE_CHOICE]: removeInvalidOptions,
  [FIELD_TYPES.CHALLENGES_SINGLE_CHOICE]: acceptOnlyValidOptionByLabel,
  [FIELD_TYPES.CHALLENGES_FILE_UPLOAD]: keepValueUnchanged,
  [FIELD_TYPES.QUIZ_SHORT_TEXT]: acceptStringValue,
  [FIELD_TYPES.QUIZ_NUMBER]: acceptNumberValue,
  [FIELD_TYPES.FILE_UPLOAD]: keepValueUnchanged,
  [FIELD_TYPES.SIGNATURE]: keepValueUnchanged,
  [FIELD_TYPES.CONTACTS_EMAIL]: acceptStringValue,
  [FIELD_TYPES.CONTACTS_PHONE]: acceptPhoneValue,
  [FIELD_TYPES.CHECKBOX]: acceptBooleanValue,
  [FIELD_TYPES.DATE_TIME_INPUT]: acceptStringValue,
  [FIELD_TYPES.CONTACTS_COMPANY]: acceptStringValue,
  [FIELD_TYPES.CONTACTS_POSITION]: acceptStringValue,
  [FIELD_TYPES.CONTACTS_TAX_ID]: acceptStringValue,
  [FIELD_TYPES.CONTACTS_FIRST_NAME]: acceptStringValue,
  [FIELD_TYPES.CONTACTS_LAST_NAME]: acceptStringValue,
  [FIELD_TYPES.CONTACTS_ADDRESS]: acceptStringValue,
  [FIELD_TYPES.CONTACTS_BIRTHDATE]: acceptStringValue,
  [FIELD_TYPES.TEXT_AREA]: acceptStringValue,
  [FIELD_TYPES.CONTACTS_SUBSCRIBE]: acceptBooleanValue,
  [FIELD_TYPES.DATE_INPUT]: acceptStringValue,
  [FIELD_TYPES.TIME_INPUT]: acceptStringValue,
  [FIELD_TYPES.DATE_PICKER]: acceptStringValue,
  [FIELD_TYPES.NESTED_FORM]: acceptObjectValue,
  [FIELD_TYPES.MULTILINE_ADDRESS]: normalizeMultilineAddress,
  [FIELD_TYPES.MLA_COUNTRY]: acceptOnlyValidOptionByValue,
  [FIELD_TYPES.MLA_CITY]: acceptStringValue,
  [FIELD_TYPES.MLA_ADDRESS_LINE]: acceptStringValue,
  [FIELD_TYPES.MLA_ADDRESS_LINE_2]: acceptStringValue,
  [FIELD_TYPES.MLA_POSTAL_CODE]: acceptStringValue,
  [FIELD_TYPES.MLA_SUBDIVISION]: acceptOnlyValidOptionByValue,
  [FIELD_TYPES.MLA_STREET_NAME]: acceptStringValue,
  [FIELD_TYPES.MLA_STREET_NUMBER]: acceptStringValue,
  [FIELD_TYPES.MLA_APARTMENT]: acceptStringValue,
  [FIELD_TYPES.FULL_NAME]: acceptFullNameValue,
  [FIELD_TYPES.FULL_NAME_FIRST_NAME]: acceptStringValue,
  [FIELD_TYPES.FULL_NAME_LAST_NAME]: acceptStringValue,
  [FIELD_TYPES.VAT_ID]: normalizeVatIDValue,
  [FIELD_TYPES.DEXT_TEXT_INPUT]: acceptStringValue,
  [FIELD_TYPES.DEXT_NUMBER_INPUT]: acceptNumberValue,
  [FIELD_TYPES.DEXT_CHECKBOX]: acceptBooleanValue,
  [FIELD_TYPES.DEXT_CHECKBOX_GROUP]: removeInvalidOptions,
  [FIELD_TYPES.DEXT_RATING_INPUT]: acceptRatingValue,
  [FIELD_TYPES.DEXT_TAGS]: removeInvalidOptions,
  [FIELD_TYPES.ECOM_ADDITIONAL_INFO]: acceptStringValue,
  [FIELD_TYPES.ECOM_ADDRESS]: acceptObjectValue,
  [FIELD_TYPES.ECOM_PHONE]: acceptPhoneValue,
  [FIELD_TYPES.ECOM_FULL_NAME]: acceptObjectValue,
  [FIELD_TYPES.ECOM_COMPANY_NAME]: acceptStringValue,
  [FIELD_TYPES.ECOM_SUBSCRIPTION]: acceptBooleanValue,
  [FIELD_TYPES.ECOM_EMAIL]: acceptStringValue,
  [FIELD_TYPES.DEXT_TEXT_AREA]: acceptStringValue,
  [FIELD_TYPES.DEXT_DROPDOWN]: acceptOnlyValidOptionByLabel,
  [FIELD_TYPES.DEXT_RADIO_GROUP]: acceptOnlyValidOptionByLabel,
  [FIELD_TYPES.DEXT_URL_INPUT]: acceptStringValue,
  [FIELD_TYPES.DEXT_EMAIL]: acceptStringValue,
  [FIELD_TYPES.DEXT_PHONE]: acceptPhoneValue,
  [FIELD_TYPES.DEXT_DATE_PICKER]: acceptStringValue,
  [FIELD_TYPES.DEXT_DATE_TIME_INPUT]: acceptStringValue,
  [FIELD_TYPES.PRODUCT_LIST]: acceptOnlyValidProducts,
  [FIELD_TYPES.DONATION]: acceptOnlyValidProducts,
  [FIELD_TYPES.RATING_INPUT]: acceptRatingValue,
  [FIELD_TYPES.TAGS]: removeInvalidOptions,
  [FIELD_TYPES.PAYMENT_INPUT]: acceptOnlyValidPayments,
  [FIELD_TYPES.FIXED_PAYMENT]: acceptOnlyValidPayments,
  [FIELD_TYPES.BOOKINGS_FIRST_NAME]: acceptStringValue,
  [FIELD_TYPES.BOOKINGS_LAST_NAME]: acceptStringValue,
  [FIELD_TYPES.BOOKINGS_EMAIL]: acceptStringValue,
  [FIELD_TYPES.BOOKINGS_PHONE]: acceptPhoneValue,
  [FIELD_TYPES.BOOKINGS_ADDRESS]: normalizeMultilineAddress,
  [FIELD_TYPES.APPOINTMENT]: acceptObjectValue,
  [FIELD_TYPES.PASSWORD]: acceptStringValue,
  [FIELD_TYPES.SERVICES_DROPDOWN]: acceptStringValue,
  [FIELD_TYPES.SERVICES_MULTI_CHOICE]: removeInvalidOptions,
  [FIELD_TYPES.EVENTS_RSVP]: acceptOnlyValidOptionByValue,
  [FIELD_TYPES.EVENTS_REPEATER]: normalizeRepeater,
  [FIELD_TYPES.IMAGE_CHOICE]: removeInvalidOptions,
  [FIELD_TYPES.PHONE]: acceptPhoneValue
};
function keepValueUnchanged(_ref) {
  let {
    fieldValue
  } = _ref;
  return fieldValue;
}
function acceptPhoneValue(_ref2) {
  let {
    fieldValue
  } = _ref2;
  const isEmptyValue = fieldValue === EMPTY_VALUE;
  if (isEmptyValue) {
    return fieldValue;
  }
  if (typeof fieldValue === 'string') {
    const stripped = fieldValue.replace(/[^0-9+]/g, '');
    return stripped || fieldValue;
  }
  return EMPTY_VALUE;
}
function removeInvalidOptions(_ref3) {
  var _field$view3, _field$view4;
  let {
    field,
    fieldValue
  } = _ref3;
  const hasAddOther = (_field$view3 = field.view) == null ? void 0 : _field$view3.addOther;
  const isEmptyValue = fieldValue === EMPTY_VALUE;
  if (hasAddOther || isEmptyValue) {
    return fieldValue;
  }
  const options = (_field$view4 = field.view) == null ? void 0 : _field$view4.options;
  if (!Array.isArray(fieldValue)) {
    return EMPTY_VALUE;
  }
  const value = fieldValue == null ? void 0 : fieldValue.filter(arrayItem => options.some(option => option.value === arrayItem || option.label === arrayItem));
  return value.length ? value : EMPTY_VALUE;
}
function acceptOnlyValidOptionByLabel(_ref4) {
  var _field$view5, _field$view6;
  let {
    field,
    fieldValue
  } = _ref4;
  const hasAddOther = (_field$view5 = field.view) == null ? void 0 : _field$view5.addOther;
  const isEmptyValue = fieldValue === EMPTY_VALUE;
  if (hasAddOther || isEmptyValue) {
    return fieldValue;
  }
  const options = (_field$view6 = field.view) == null ? void 0 : _field$view6.options;
  const optionExists = options.some(option => option.value === fieldValue || option.label === fieldValue);
  return optionExists ? fieldValue : EMPTY_VALUE;
}
function acceptOnlyValidProducts(_ref5) {
  var _validation$predefine, _validation$predefine2;
  let {
    field,
    fieldValue
  } = _ref5;
  const isEmptyValue = fieldValue === EMPTY_VALUE;
  if (isEmptyValue) {
    return fieldValue;
  }
  if (!Array.isArray(fieldValue)) {
    return EMPTY_VALUE;
  }
  const validation = field.validation;
  if ((validation == null || (_validation$predefine = validation.predefined) == null ? void 0 : _validation$predefine.format) !== ValidationFormat.PAYMENT) {
    return EMPTY_VALUE;
  }
  const validationProducts = ((_validation$predefine2 = validation.predefined.paymentOptions) == null ? void 0 : _validation$predefine2.products) || [];
  if (validationProducts.length === 0) {
    return EMPTY_VALUE;
  }
  const validProducts = fieldValue.filter(productValue => {
    const hasAllProps = isObject(productValue) && productValue.hasOwnProperty('productId') && productValue.hasOwnProperty('price') && productValue.hasOwnProperty('quantity');
    if (!hasAllProps) {
      return false;
    }
    const price = productValue.price;
    const isValidPrice = isString(price) ? Number(price).toString() === price : isNumber(price);
    if (!isValidPrice) {
      return false;
    }
    const isValidQuantity = isNumber(productValue.quantity);
    if (!isValidQuantity) {
      return false;
    }
    const isExisted = validationProducts.some(product => product.id === productValue.productId);
    return isExisted;
  });
  return validProducts.length ? validProducts : EMPTY_VALUE;
}
function acceptOnlyValidOptionByValue(_ref6) {
  var _field$view7;
  let {
    field,
    fieldValue
  } = _ref6;
  const isEmptyValue = fieldValue === EMPTY_VALUE;
  if (isEmptyValue) {
    return fieldValue;
  }
  const options = (_field$view7 = field.view) == null ? void 0 : _field$view7.options;
  if (!options) {
    return EMPTY_VALUE;
  }
  const optionExists = options.some(option => option.value === fieldValue);
  return optionExists ? fieldValue : EMPTY_VALUE;
}
function normalizeVatIDValue(_ref7) {
  let {
    fieldValue
  } = _ref7;
  const vatID = fieldValue;
  const isEmptyValue = fieldValue === EMPTY_VALUE;
  if (isEmptyValue) {
    return fieldValue;
  }
  if (fieldValue && isObject(fieldValue) && fieldValue.hasOwnProperty('id')) {
    if (fieldValue.hasOwnProperty('type')) {
      const type = getVatIDType(vatID.id);
      return {
        id: vatID.id,
        type
      };
    }
    return {
      id: vatID.id
    };
  }
  return EMPTY_VALUE;
}
function acceptNumberValue(_ref8) {
  let {
    fieldValue
  } = _ref8;
  const isEmptyValue = fieldValue === EMPTY_VALUE;
  if (isEmptyValue) {
    return fieldValue;
  }
  return isNumber(fieldValue) ? fieldValue : EMPTY_VALUE;
}
function acceptStringValue(_ref9) {
  let {
    fieldValue
  } = _ref9;
  const isEmptyValue = fieldValue === EMPTY_VALUE;
  if (isEmptyValue) {
    return fieldValue;
  }
  return isString(fieldValue) ? fieldValue : EMPTY_VALUE;
}
function acceptBooleanValue(_ref0) {
  var _field$validation, _field$view8;
  let {
    fieldValue,
    field
  } = _ref0;
  const isEmptyValue = fieldValue === EMPTY_VALUE;
  if (isEmptyValue) {
    return fieldValue;
  }
  if (fieldValue === false && (_field$validation = field.validation) != null && _field$validation.required && ((_field$view8 = field.view) == null ? void 0 : _field$view8.defaultValue) === false && field.hidden) {
    return EMPTY_VALUE;
  }
  const isBoolean = typeof fieldValue === 'boolean';
  return isBoolean ? fieldValue : EMPTY_VALUE;
}
function normalizeMultilineAddress(_ref1) {
  var _config$addressTempla;
  let {
    fieldValue,
    config,
    field
  } = _ref1;
  const isEmptyValue = fieldValue === EMPTY_VALUE;
  if (isEmptyValue) {
    return EMPTY_VALUE;
  }
  const addressForms = config == null || (_config$addressTempla = config.addressTemplates) == null ? void 0 : _config$addressTempla.map(template => template.template);
  if (!addressForms) {
    return EMPTY_VALUE;
  }
  const addressToolkit = new MultilineAddressToolkit(addressForms);
  const country = fieldValue == null ? void 0 : fieldValue.country;
  const template = addressToolkit.getFormByCountry(country, field);
  return normalizeValues(template, fieldValue, true, config);
}
function acceptObjectValue(_ref10) {
  let {
    fieldValue
  } = _ref10;
  const isEmptyValue = fieldValue === EMPTY_VALUE;
  if (isEmptyValue) {
    return fieldValue;
  }
  return typeof fieldValue === 'object' ? fieldValue : EMPTY_VALUE;
}
function acceptFullNameValue(args) {
  const result = acceptObjectValue(args);
  return result === EMPTY_VALUE ? {} : result;
}
function acceptRatingValue(_ref11) {
  let {
    fieldValue
  } = _ref11;
  const isEmptyValue = fieldValue === 0 || fieldValue === EMPTY_VALUE;
  if (isEmptyValue) {
    return EMPTY_VALUE;
  }
  return isRating(fieldValue) ? fieldValue : EMPTY_VALUE;
}
function acceptOnlyValidPayments(_ref12) {
  var _validation$predefine3;
  let {
    field,
    fieldValue
  } = _ref12;
  const isEmptyValue = fieldValue === EMPTY_VALUE;
  const {
    validation
  } = field;
  const payment = validation == null || (_validation$predefine3 = validation.predefined) == null || (_validation$predefine3 = _validation$predefine3.paymentOptions) == null || (_validation$predefine3 = _validation$predefine3.products) == null ? void 0 : _validation$predefine3[0];
  if (isEmptyValue && (payment == null ? void 0 : payment.priceType) === PriceType.FIXED_PRICE) {
    var _payment$fixedPriceOp;
    return [{
      productId: payment.id,
      price: (_payment$fixedPriceOp = payment.fixedPriceOptions) == null ? void 0 : _payment$fixedPriceOp.price,
      quantity: 1
    }];
  }
  if (isEmptyValue) {
    return fieldValue;
  }
  if (!Array.isArray(fieldValue)) {
    return EMPTY_VALUE;
  }
  return fieldValue;
}
function normalizeRepeater(_ref13) {
  var _field$view9;
  let {
    field,
    fieldValue,
    config
  } = _ref13;
  const isEmptyValue = fieldValue === EMPTY_VALUE;
  const nestedFields = (_field$view9 = field.view) == null ? void 0 : _field$view9.fields;
  if (isEmptyValue) {
    return fieldValue;
  }
  if (!Array.isArray(fieldValue) || !nestedFields) {
    return EMPTY_VALUE;
  }
  const nestedForm = {
    fields: nestedFields
  };
  const normalizedValues = fieldValue.map(values => {
    if (!isObject(values)) {
      return {};
    }
    const normalized = normalizeValues(nestedForm, values, false, config);
    return Object.fromEntries(Object.entries(normalized).filter(_ref14 => {
      let [_, value] = _ref14;
      return value !== EMPTY_VALUE;
    }));
  });
  return normalizedValues;
}
//# sourceMappingURL=normalize-values.js.map